export default __webpack_public_path__ + "static/media/placeholder-league-logo.1f225c7a.svg";